import { Component, OnDestroy, inject } from '@angular/core';
import { DevicesRouterStoreSelectors, NotesStoreActions, NotesStoreSelectors } from '@era/stores';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Note } from '@rocksoft/mdm-sdk-v2';
import { NotesListComponent } from '@rocksoft/shared';
import { Subscription } from 'rxjs';
import { first, tap } from 'rxjs/operators';

@Component({
  selector: 'era-notes-modal',
  templateUrl: './notes-modal.container.html',
  imports: [NotesListComponent],
})
export class NotesModalComponent implements OnDestroy {
  public readonly activeModal = inject(NgbActiveModal);
  private readonly store = inject(Store);

  public readonly currentUdid = this.store.selectSignal(NotesStoreSelectors.selectNotesForCurrentUdid);
  private readonly subscriptions: Subscription[] = [];

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  public noteAdded(note: Note): void {
    this.subscriptions.push(
      this.store
        .select(DevicesRouterStoreSelectors.selectUdid)
        .pipe(
          first(),
          tap((udid) => {
            if (!udid) {
              return;
            }

            this.store.dispatch(NotesStoreActions.NotesUIActions.noteAdded({ note, udid }));
          })
        )
        .subscribe()
    );
  }

  public noteDeleted(note: Note): void {
    this.subscriptions.push(
      this.store
        .select(DevicesRouterStoreSelectors.selectUdid)
        .pipe(
          first(),
          tap((udid) => {
            if (!udid) {
              return;
            }

            this.store.dispatch(NotesStoreActions.NotesUIActions.noteDeleted({ note, udid }));
          })
        )
        .subscribe()
    );
  }
}
